<template>
    <el-main>
        <div class="control-bar">
            <span class="title">红豆订单</span>
            <el-form :inline="true" size="small">
                <el-form-item>
                    <el-input v-model="filters.wd" placeholder="手机号码/系统订单号" clearable @clear="getLists(1)"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="filters.status" placeholder="订单状态" clearable @change="getLists(1)">
                        <el-option v-for="(item,index) in $config.paystatus" :key="index" :label="item"
                            :value="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getLists(1)">查询</el-button>
                </el-form-item>
            </el-form>
        </div>

        <el-table :data="lists" border header-cell-class-name="table-header">
            <el-table-column label="序号" align="center" prop="id" width="80"></el-table-column>
            <el-table-column label="姓名" prop="realname" align="center" width="100">
                <template slot-scope="scope">{{ scope.row.realname || '-' }}</template>
            </el-table-column>
            <el-table-column label="手机号码" prop="mobile" align="center" width="130">
            </el-table-column>
            <el-table-column label="支付金额" width="120">
                <template slot-scope="scope">
                    <span style="color: #dc6b91; font-weight: 600;">{{ scope.row.fee | fenToYuan(2) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="红豆数量" prop="amount" align="center" width="100"></el-table-column>
            <el-table-column label="支付渠道" align="center" width="90">
                <template slot-scope="scope">{{$config.payChannels[scope.row.channel]}}</template>
            </el-table-column>
            <el-table-column label="系统订单号" prop="trade_no" align="center" width="200">
            </el-table-column>
            <el-table-column label="支付订单号" prop="out_trade_no" align="center" width="260">
            </el-table-column>
            <el-table-column label="订单状态" align="center" width="100">
                <template slot-scope="scope">
                    {{$config.paystatus[scope.row.status]}}
                </template>
            </el-table-column>
            <el-table-column label="下单时间" prop="dateline" align="center" width="170">
                <template slot-scope="scope">{{ scope.row.dateline | timeTodate("Y-m-d H:i:s") }}</template>
            </el-table-column>
        </el-table>

        <el-pagination background layout="sizes, prev, pager, next, total" :page-sizes="[10, 15, 20, 50, 100]"
            @size-change="handleSizeChange" @current-change="getLists" :current-page="page"
            :page-size="$store.state.offset" :total="totals">
        </el-pagination>
    </el-main>
</template>

<script>
    import {
        httpRequest,
        getCookie
    } from '@/utils/app'
    export default {
        data() {
            return {
                admin: {},
                totals: 0,
                page: 1,
                lists: [],
                filters: {
                    wd: '',
                    status: ''
                }
            }
        },
        created() {
            this.admin = getCookie('admin')
            this.getLists(1)
        },
        methods: {
            // 每页条数变更：写入 Vuex + localStorage（全局共享）后重新加载
            handleSizeChange(e) {
                this.$store.commit('setOffset', e)
                this.getLists(1)
            },
            getLists(page) {
                let params = {
                    action: 'payment_lists',
                    type: 2,
                    page: page,
                    offset: this.$store.state.offset,
                    ord: 'id desc'
                }
                if (this.filters.wd) {
                    if (this.filters.wd.length == 13) {
                        params.mobile = this.filters.wd
                    } else {
                        params.trade_no = this.filters.wd
                    }
                }
                // 订单状态筛选（0=全部不下发；1待支付/2已支付/3已取消/4已退款）
                if (this.filters.status) params.status = this.filters.status
                httpRequest(params).then(response => {
                    if (response.error === false) {
                        this.page = page
                        this.lists = response.data
                        this.totals = parseInt(response.totals)
                    } else {
                        this.$message({
                            type: 'error',
                            message: response.msg || '加载失败'
                        })
                    }
                })
            }
        }
    }
</script>